<template>
  <div>
    <div class="page page__wrapper wrapper">
      <FlashMessageContainer :messages="messages"></FlashMessageContainer>
      <LoadingIndicator></LoadingIndicator>
      <Header></Header>
      <div class="page__row" id="top">
        <div class="page__sidebar">
          <Sidebar></Sidebar>
          <SidebarMobile></SidebarMobile>
          <ContactTeamModals></ContactTeamModals>
        </div>
        <div class="page__main">
          <section class="page__container container-fluid">
            <MainColumn :component-name="componentName" :sub-component-name="subComponentName" class="page__content"></MainColumn>
          </section>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Header from '../components/layout/Header.vue';
  import Sidebar from '../components/layout/Sidebar.vue';
  import SidebarMobile from '../components/layout/SidebarMobile.vue';
  import ContactTeamModals from '../components/sidebar/ContactTeamModals.vue';
  import MainColumn from '../components/layout/MainColumn.vue';
  import Footer from '../components/layout/Footer.vue';
  import LoadingIndicator from '../components/layout/LoadingIndicator.vue';
  import FlashMessageContainer from '../components/layout/FlashMessageContainer.vue';

  export default {
    name: 'LoggedInLayout',
    props: {
      componentName: {
        type: String,
        required: true,
      },
      subComponentName: {
        type: String,
        required: false,
      },
    },
    components: {
      FlashMessageContainer,
      Header,
      Sidebar,
      SidebarMobile,
      ContactTeamModals,
      MainColumn,
      Footer,
      LoadingIndicator,
      FlashMessageContainer,
    },
    computed: {
      ...mapGetters('flash', ['messages']),
    },
  };
</script>
